/**
 * Checkbox style 1
 *
 * Example:
 * <checkbox1 label="my label" value="my value"></checkbox1>
 */
app.directive('checkbox1', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox1.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '@value',
            label: '@label',
            name: '@name',
            ngModel: "="
        },
        link: function ($scope, $element, $attr, controller, transclude) {

        }
    };
}]);


/**
 * Checkbox style 2
 *
 * Example:
 * <checkbox2 label="my label" value="my value"></checkbox2>
 */
app.directive('checkbox2', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox2.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '@value',
            label: '@label',
            name: '@name',
            ngModel: "=",
            ngChange: '&',
            ngClick: '&',
            tooltipTitle: '@tooltipTitle',
            level: '=',
            ngDisabled: '='
        },
        link: function ($scope, $element, $attr, controller, transclude) {
            $scope.ngChange = $scope.ngChange || function () {};
            $scope.ngClick = $scope.ngClick || function () {};
            $($element).off('keyup').on('keyup', function (e) {
                if ($scope.stopPropagation) {
                    e.stopPropagation();
                }
                if (e.keyCode === 32) {
                    $element.find('input').trigger('click');
                }
            });

            $($element).off('click').on('click', function (event) {

                var target = event.target || event.srcElement;

                if ($(target).attr("type") != 'checkbox') {
                    $($element).find('input').trigger('click');
                }
            });

            $($element).find('input').on('change', function () {
                $scope.ngClick();
                $scope.ngChange();
            })

            $scope.$on('$destroy', function () {
                $($element).off('click keyup');
            });

        }
    };
}]);

/**
 * hCheckbox - Custom checkbox with congigurable icon
 */
app.directive('hCheckbox', ['$timeout', function ($timeout) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/hCheckbox.html",
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            value: '@value',
            label: '@label',
            offLabel: '@offLabel',
            name: '@name',
            ngModel: "=",
            ngDisabled: "=",
            ngChange: '=',
            onChange: '&',
            offIcon: '@',
            onIcon: '@',
            hoverIcon: '&',
            theme: "@",
            disabledLabel: "@",
            stopPropagation: "<",
            hAriaLabel: '@',
            hLabelId: '@'
        },
        link: function ($scope, $element, $attr, controller, transclude) {

            $scope.offIcon = $attr.offIcon || 'square-o';
            $scope.onIcon = $attr.onIcon || 'check-square';


            var setIcon = function () {

            };

            if ($attr.hoverIcon) {
                $element.find('.h-checkbox-icon').mouseover(function () {
                    $(this).find('i').addClass('fa fa-' + $attr.hoverIcon);
                });

                $element.find('.h-checkbox-icon').mouseout(function () {
                    $(this).find('i').removeClass('fa-' + $attr.hoverIcon);
                });
            }

            $element.find("i, label").off('click keypress');

            $element.find("i, label").on('keypress', function (e) {
                if ($scope.stopPropagation) {
                    e.stopPropagation();
                }
                if (e.charCode === 32) {
                    $element.find('input').trigger('click');
                }
            });

            $element.find("i, label").on('click', function (e) {
                if ($scope.stopPropagation) {
                    e.stopPropagation();
                }
                $element.find('input').trigger('click');
            });

            $element.find('input').click(function (e) {
                if ($scope.stopPropagation) {
                    e.stopPropagation();
                }
                if ($attr.ngChange) {
                    $timeout(function () {
                        $scope.ngChange({name: $scope.name, value: $scope.ngModel});
                    }, 1);
                }

                if ($attr.onChange) {
                    $timeout(function () {
                        $scope.onChange({name: $scope.name, value: $scope.ngModel});
                    }, 1);
                }

                setIcon();
            });

            $scope.ngModel = !!$scope.ngModel;

            $scope.$on('$destroy', function () {
                $element.find("i, label").off('click keypress');
            });

            setIcon();
        }
    };
}]);


/**
 * Checkbox style 3
 *
 * Example:
 * <checkbox3 label="my label" value="my value"></checkbox3>
 */
app.directive('checkbox3', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox3.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '@value',
            label: '@label',
            name: '@name',
            ngModel: "=",
            ngRequired: '=?',
            ngChange: '&',
            smallCheckBox: '=?',
            ngDisabled: "="
        },
        link: function ($scope, $element, $attr, controller, transclude) {
            $scope.ngRquired = $scope.ngRquired ? $scope.ngRquired : false;
        }
    };
}]);


/**
 * Checkbox style 4
 *
 * Example:
 * <checkbox4 label="my label" value="my value"></checkbox4>
 */
app.directive('checkbox4', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox4.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '@value',
            label: '@label',
            name: '@name',
            ngModel: "="
        },
        link: function ($scope, $element, $attr, controller, transclude) {

        }
    };
}]);

/**
 * Checkbox style 5
 *
 * Example:
 * <checkbox5 label="my label" value="my value" ng-model="" name=""></checkbox5>
 */
app.directive('checkbox5', ['$timeout', function ($timeout) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox5.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            label: '=',
            name: '@name',
            ngModel: "=",
            ngDisabled: "=",
            checked: '='
        },
        link: function ($scope, $element, $attr, controller, transclude) {
            var $input = $element.find('input');

            if ($scope.ngDisabled) {
                $input.attr('disabled', 'disabled');
                $element.addClass('disabled');
            }

            $input.unbind('click');

            // listener on input to prevent double event firing !
            $input.click(function (e) {
                $scope.ngModel = $input.is(":checked");
                $timeout(function () {
                    if ($scope.$parent && $scope.$parent.$parent) {
                        // $scope.$parent.$parent.form.validate();

                        // Search for the form model in order to trigger the onChange callback
                        var formScope = $scope.$parent.$parent;

                        for (var i = 0; i < 5; i++) {
                            if (formScope.form) {
                                formScope = formScope.form;
                                break;
                            }
                            else if (formScope.$parent) {
                                formScope = formScope.$parent;
                            }
                        }

                        // Search for the form model in order to trigger the onChange callback
                        if (!formScope.onChange && formScope.items) {
                            for (var i in formScope.items) {
                                if (formScope.items[i].title === $($element).text().trim()) {
                                    formScope = formScope.items[i];
                                    break;
                                }
                            }
                        }

                        if (formScope && formScope.onChange) {
                            formScope.onChange($scope.ngModel, formScope);
                        }

                        if (formScope && formScope.validate) {
                            setTimeout(function () {
                                formScope.validate();
                            }, 1);
                        }
                    }
                    $scope.$apply();
                })
                $element.toggleClass('checked');

            });

            if ($scope.checked) {
                $timeout(function () {
                    $input.trigger('click');
                });
            }

            //This will ensure a two way data binding between the model and the checkbox(checked class)
            //so that when the model is changed we make sure to the checkbox toggle its checked calss according the value of the model
            $scope.$watch('ngModel', function (newVal, oldVal) {
                var input = $element.find('input');
                if (newVal === true && !$element.hasClass('checked')) {
                    $element.addClass('checked');
                }
                else if (newVal === false && $element.hasClass('checked')) {
                    $element.removeClass('checked');

                }
            });
        }
    };
}]);

/**
 * Checkbox style 6 - same as 5 but the element checked when ngModel is checked, checkbox 5 used for special purposes
 * of sync widget in job creation form.
 *
 * Example:
 * <checkbox6 label="my label" value="my value" ng-model="" name=""></checkbox6>
 */
app.directive('checkbox6', ['$timeout', function ($timeout) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox6.html",
        restrict: 'E',
        replace: true,
        require: '^form',
        scope: {
            value: '=',
            label: '=',
            name: '@name',
            ngModel: "=",
            ngDisabled: "=",
            ngChange: "&",
        },
        link: function ($scope, $element, $attr, formCtrl, transclude) {

            var trigger = function(){
                if ($scope.ngDisabled) {
                    return;
                }

                /* Solve Dirty bit Problem for the input
                 should change later to resolve the scope issue
                 */
                if ($scope && $scope.name && formCtrl && formCtrl[$scope.name]) {
                    formCtrl[$scope.name].$dirty = true;
                }

                $scope.ngModel = !$scope.ngModel;
                $scope.ngChange({value: $scope.ngModel});

                //formCtrl.$setDirty();
                $timeout(function () {
                    $scope.$apply();
                    $element.find("input").change();
                });
            };

            $element.keypress(function (e) {
                if (e.which === 32) {
                    trigger();
                }
            });

            $element.click(function () {
                trigger();
            });
        }
    };
}]);

/**
 * Checkbox style 7 - same as 6 with an extra icon at the top
 *
 * Example:
 * <checkbox7 label="my label" value="my value" ng-model="" name=""></checkbox6>
 */
app.directive('checkbox7', ['$timeout', function ($timeout) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox7.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            label: '=',
            name: '@name',
            ngModel: "=",
            icon: '@icon'
        },
        link: function ($scope, $element, $attr, controller, transclude) {

        }
    };
}]);

/**
 * Checkbox style 7 - same as 6 with an extra icon at the top
 *
 * Example:
 * <checkbox7 label="my label" value="my value" ng-model="" name=""></checkbox6>
 */
app.directive('checkbox7Enabled', ['$timeout', function ($timeout) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/checkbox7-enabled.html",
        restrict: 'E',
        replace: true,
        scope: {
            value: '=',
            label: '=',
            name: '@name',
            ngModel: "=",
            icon: '@icon'
        },
        link: function ($scope, $element, $attr, controller, transclude) {
            $scope.ngModel = true;
            $('[data-toggle="tooltip"]').tooltip()
        }
    };
}]);


/**
 * RadioItem Harri style :)
 *
 * Example
 <radio-item label="'Full time'" name="availability" value="mmm" ng-model="availability"></radio-item>
 <radio-item label="'PART TIME'" name="availability" value="mmm" ng-model="availability"></radio-item>
 <radio-item label="'SEASONAL'" name="availability" value="mmm" ng-model="availability"></radio-item>
 <radio-item label="'ON CALL'" name="availability" value="mmm" ng-model="availability"></radio-item>
 */
app.directive('radioItem', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/radio_item.html",
        restrict: 'E',
        replace: true,
        scope: {
            'label': '=',
            'checked': '=',
            'value': '@',
            'ngModel': '=',
            'hrequired': '=?',
            'name': '@',
            'ngChange': '&',
            'ngDisabled': '=',
            'onClick': '&'
        },
        link: function (scope, element, iAttrs) {

            var $input = element.find('input');

            if (scope.ngDisabled) {
                $input.attr('disabled', 'disabled');
                element.find('label').addClass('disabled');
            }

            $input.click(function (e) {
                //e.preventDefault();
                if (scope.name) {
                    $('label.radio-item.' + scope.name).removeClass('checked');
                    element.find('label').addClass('checked');
                }

                scope.onClick();
            });

            $input.change(function (e) {
                //e.preventDefault();
                if (scope.ngChange) {
                    scope.ngChange();
                }
            });
        }
    };
}]);


app.directive('radioHtmlItem', ['$timeout', function ($timeout) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/radio_html_item.html",
        restrict: 'E',
        replace: true,
        transclude: true,
        scope: {
            'label': '=label',
            'checked': '=checked',
            'value': '@value',
            'ngModel': '=ngModel',
            'name': '@name'
        },
        link: function (scope, element, iAttrs) {

            var $input = element.find('input');
            $input.click(function (e) {
                //e.preventDefault();
                if (scope.name) {
                    $('.radio-item.' + scope.name).removeClass('checked');
                    element.addClass('checked');
                }

            });

        }
    };
}]);

/**
 * Input Style 1
 *
 * <input1 ng-model="data.application.first_name" placeholder="{{'First Name'|translate}}"
 ng-required="true" name="first_name" icon="fa-user" />
 */
app.directive('input1', ['$timeout', '$compile', function ($timeout, $compile) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/input1.html",
        restrict: 'E',
        replace: true,
        require: 'ngModel',
        scope: {
            'value': '@',
            'type': '@?',
            'ngModel': '=',
            'ngRequired': '=',
            'name': '@',
            'placeholder': '@',
            'icon': '@',
            'id': '@',
            'ngMinlength': '=?',
            'ngMaxlength': '=?',
            'autocompletetype': "@?",
            'ngPattern': '=',
            'hPassword': '=',
            'iconPath': '@'
        },
        link: function (scope, element, attrs, ngModel) {
            scope.type = scope.type ? scope.type : 'text';
            scope.ngMinlength = scope.ngMinlength ? scope.ngMinlength : 0;
            //fix email: ayman@harri the case is when you try to add `.` it will reset it self
//            $timeout(function () {
            var $input = element.find('input');

            if (attrs.disabled) {
                $input.attr("disabled", attrs.disabled);
            }

            $input.focus(function () {
                $(this).parent().addClass('h-focus');
            }).blur(function () {
                if ($.trim(this.value) == '') {
                    $(this).parent().removeClass('h-focus');
                }

                if (ngModel.$invalid) {
                    $(element).closest('.form-group').addClass('has-error');
                } else {
                    $(element).closest('.form-group').removeClass('has-error');
                }

            });
        }
    };
}]);

/**
 * InputSwitch
 *
 * Example:
 * <input-switch label="my label" value="my value"></input-switch>
 */
app.directive('inputSwitch', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/input_switch.ng.html",
        restrict: 'E',
        scope: {
            'value': '@value',
            'label': '@label',
            'name': '@name',
            'hName': '@hName',
            'ngModel': "=",
            'ngRequired': '=?',
            'onChange': '&',
            'ngDisabled': '='
        },
        link: function ($scope, $element, $attr, controller, transclude) {
            $scope.name = $scope.name || $scope.hName;
            $($element).find('input').on('change', function () {
                $scope.onChange && $scope.onChange();
                $scope.$apply();
            });
        }
    };
}]);


app.directive('numberTicker', ['deviceChecker', function (deviceChecker) {
    return {
        templateUrl: "../modules/forms/components/customControls/html/number_ticker.html",
        restrict: 'E',
        replace: true,
        scope: {
            'name': '@name',
            'ngModel': "=",
            'minValue': "=?"
        },
        link: function ($scope, $element, $attr) {
            $scope.type = deviceChecker.isMobile() ? "number" : "text";

            $scope.minValue = $scope.minValue || 0;

            $scope.addAmount = function (amount) {
                $scope.ngModel += amount;
                $scope.setValidValue();
            };


            $scope.setValidValue = function () {
                if (!isNaN(parseInt($scope.ngModel))) {
                    var amount = parseInt($scope.ngModel);

                    if (amount < $scope.minValue) {
                        $scope.ngModel = $scope.minValue;
                    } else {
                        $scope.ngModel = amount;
                    }
                } else {
                    $scope.ngModel = $scope.minValue;
                }

                setTimeout(function () {
                    $element.find("input").change();
                }, 100);
            }
        }
    };
}]);

app.directive('hDaysSelector', [function () {
    return {
        templateUrl: "../modules/forms/components/customControls/html/h_days_selector.html",
        restrict: 'E',
        replace: true,
        scope: {
            'name': '@name',
            'weekStartDay': "=?",
            'dayToSelect': "=?",
            'ngModel': "=",
            'ngChanged': "=?"
        },
        link: function ($scope, $element, $attr) {
            $scope.ngChanged = $scope.ngChanged || function(){};
            $scope.daysOfWeek = [
                {name: "Sun", code: "sun", selected: false, lastDay: false},
                {name: "Mon", code: "mon", selected: false, lastDay: false},
                {name: "Tue", code: "tue", selected: false, lastDay: false},
                {name: "Wed", code: "wed", selected: false, lastDay: false},
                {name: "Thu", code: "thu", selected: false, lastDay: false},
                {name: "Fri", code: "fri", selected: false, lastDay: false},
                {name: "Sat", code: "sat", selected: false, lastDay: false}
            ];

            var orderedDaysOfWeek = [];

            //Update  the week start day
            $scope.weekStartDay = $scope.weekStartDay || 'Mon';

            if (orderedDaysOfWeek.length == 0) {
                for (var index in $scope.daysOfWeek) {
                    var day = $scope.daysOfWeek[index];
                    if (day.name.toLowerCase() == $scope.weekStartDay.toLowerCase()) {
                        orderedDaysOfWeek.push(day);
                        startDayIndex = index;
                        break;
                    }
                }

                orderedDaysOfWeek = $scope.daysOfWeek.slice(startDayIndex, $scope.daysOfWeek.length);
                if (index != 0) {
                    Array.prototype.push.apply(orderedDaysOfWeek, $scope.daysOfWeek.slice(0, startDayIndex));
                }

                orderedDaysOfWeek[orderedDaysOfWeek.length - 1].lastDay = true;
            }

            // Select the first day
            if ($scope.dayToSelect) {
                for (var index in orderedDaysOfWeek) {
                    var day = orderedDaysOfWeek[index];
                    if (day.name == $scope.dayToSelect) {
                        day.selected = true;
                        break;
                    }
                }
            }

            $scope.orderedDaysOfWeek = orderedDaysOfWeek;
            $scope.ngModel = $scope.orderedDaysOfWeek;

            /**
             * Toggle the selection of the day
             * @param day
             */
            $scope.toggleDay = function (day) {
                if (day.name != $scope.dayToSelect) {
                    day.selected = !day.selected;
                }

                $scope.ngChanged();
            };

            $scope.$watch("dayToSelect", function (newVal, oldVal) {
                for (var index in orderedDaysOfWeek) {
                    var day = orderedDaysOfWeek[index];
                    if (day.name == $scope.dayToSelect) {
                        day.selected = true;
                    }else{
                        day.selected = false
                    }
                }
            }, true);
        }
    };
}]);

/*
* This directive for phone fields.
*
* For forms that handled using angularjs:
* Example: <input type="tel" h-intl-tel-input="{validate:true}">
*
* For forms that handled using jquery:
* Example: <input type="tel" h-intl-tel-input validate-rule="phoneNumber">
* */

app.directive('hIntlTelInput', ['hUser', '$timeout', function (hUser, $timeout) {

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            ngModel: '=',
            hIntlTelInput: '=?'
        },
        link: function (scope, elm, attrs, ngModelController) {
            // dom reference
            var input = elm[0], intlTelInputInstance;
            var countryChangeLock = false;
            var formatNumber = function (phoneNumber) {
                phoneNumber = phoneNumber || "";
                var selectedCountryData = intlTelInputInstance.getSelectedCountryData();
                var dialCode = '+' + selectedCountryData.dialCode;
                var spacesIndices = [];
                var minCheckLength = dialCode.length;

                if (dialCode === "+44") {
                    spacesIndices = [3, 7, 13];
                } else if (dialCode === "+1") {
                    spacesIndices = [2, 5, 8, 12];
                }

                if (phoneNumber.length > minCheckLength) {
                    phoneNumber = phoneNumber.replace(/ /g, "");

                    if (spacesIndices.length) {
                        var number = phoneNumber;
                        var numberParts = [];
                        var activePart = 0;
                        var shift = 0;
                        var nextSpaceIndex = 0;

                        for (var i = 0; i < number.length; i++) {
                            if (spacesIndices[nextSpaceIndex] == (parseInt(i) - shift)) {
                                if (!isNaN(number[i])) {
                                    activePart++;
                                } else {
                                    shift++;
                                }
                                nextSpaceIndex++;
                            }

                            numberParts[activePart] = numberParts[activePart] || "";
                            numberParts[activePart] += number[i];
                        }

                        phoneNumber = numberParts.join(" ");
                    }
                }

                return phoneNumber;
            };

            var initDialCode = function () {
                var countryData = intlTelInputInstance.getSelectedCountryData();
                scope.ngModel = "+" + countryData.dialCode;
                intlTelInputInstance.setNumber(scope.ngModel);
            };

            var syncNgModel = function(){
                /* ░░ Sync Ngmodel with intlTelInput ░░ */
                var currentNumber = intlTelInputInstance.getNumber();
                if(currentNumber){
                    scope.ngModel = formatNumber(currentNumber);
                    countryChangeLock =true;
                    intlTelInputInstance.setNumber(scope.ngModel);
                }
                else{
                    initDialCode();
                }
            };

            function init(countryCode){
                intlTelInputInstance = window.intlTelInput(input, {
                    nationalMode: false,
                    autoHideDialCode: false,
                    initialCountry: countryCode,
                    autoPlaceholder: "aggressive",
                    preferredCountries: ["us", "gb", "ae"],
                    excludeCountries: ["af"],
                    customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {

                        var placeholder = selectedCountryPlaceholder;

                        if (selectedCountryData.iso2 === 'us') {
                            placeholder = "+1 415 555 2671";
                        } else if (selectedCountryData.iso2 === 'gb') {
                            placeholder = "+44 7911 123456";
                        }

                        return placeholder;
                    },
                    separateDialCode: false
                });


                // sync with angular
                input.addEventListener("countrychange", function() {
                    if (countryChangeLock) {
                        countryChangeLock = false;
                        return;
                    }
                    var currentNumber = intlTelInputInstance.getNumber();
                    syncNgModel(currentNumber);
                    scope.$digest();
                });

                scope.$watch("ngModel", function (value, oldVal) {
                    if (elm[0].selectionStart !== elm.val().length) {
                        var position = elm[0].selectionStart;
                        setTimeout(function () {
                            elm[0].setSelectionRange(position, position)
                        }, 50);
                    }

                    if (!oldVal && !value) {
                        initDialCode();
                    } else if ( value && value !== oldVal){
                        syncNgModel(value);
                    }

                });

                if (scope.hIntlTelInput && scope.hIntlTelInput.validate) {
                    ngModelController.$validators.validPhoneNumber = function (modelValue, viewValue) {
                        if (ngModelController.$isEmpty(modelValue)) {
                            return true;
                        }
                        return !!(window.intlTelInputUtils.isValidNumber(modelValue));
                    };
                }
            }

            hUser.getUserLocation().then(function (resp) {
                init(resp.countryCode);
            });

            elm.on('$destroy', function () {
                if(intlTelInputInstance){
                    intlTelInputInstance.destroy();
                }
            });

        }
    }
}]);